import { useContext } from 'react';
import styled from 'styled-components';
import link from 'next/link';
import { Trans } from '@lingui/react';
import Icon from '@components/Icon';
import { Popover, PopoverTrigger, PopoverContent } from 'src/ui/popover';
import LanguageContext from '@lib/contexts/languageContext';
import { BundleEssentialFieldsFragment } from '@gql/generated';

const Wrapper = styled.div``;

const Link = styled(link)`
  color: #242424;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  border: none; //1px solid ${({ theme }) => theme.colors.neutrals['gray-3']};
  border-radius: 5px;
  padding: 12px 0px;
  background: none;
  cursor: pointer;

  [name='ygb-icon-menu-hor'] {
    transform: rotate(90deg);

    :before {
      color: ${({ theme }) => theme.colors.neutrals['gray']};
    }
  }

  :hover {
    background-color: ${({ theme }) => theme.colors.neutrals['white-darker']};
  }
`;

type Props = {
  className?: string;
  bundle: BundleEssentialFieldsFragment;
};
export const BundleExtendAccessMenu = (props: Props) => {
  const lang = useContext(LanguageContext);

  const { client, slug } = props.bundle;

  return (
    <Wrapper className={props.className}>
      <Popover>
        <PopoverTrigger>
          <Icon name="ygb-icon-menu-hor" fontSize="5px" />
        </PopoverTrigger>
        <PopoverContent>
          <Link
            className="px-4 py-2"
            href={`/${lang}/c/${client?.slug}/b/${slug}/get-started`}
          >
            <Trans id="programs_2021.header.extend_access" />
          </Link>
        </PopoverContent>
      </Popover>
    </Wrapper>
  );
};
